import styled from 'styled-components';

export const JobTemplateListStyle = styled.div`
  .link-class {
    &:hover,
    &:active {
      color: ${({ theme }) => theme.palette.primary} !important;
    }
  }
`;
